import { useState, useEffect } from 'react';
import { optimizeImage } from '@/utils/image';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  lazy?: boolean;
}

const Image = ({ src, alt, width, height, lazy = true, ...props }: ImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const optimizedSrc = width ? optimizeImage(src, width) : src;

  useEffect(() => {
    const img = document.createElement('img');
    img.src = optimizedSrc;
    img.onload = () => setLoaded(true);
  }, [optimizedSrc]);

  return (
    <img
      src={optimizedSrc}
      alt={alt}
      width={width}
      height={height}
      loading={lazy ? 'lazy' : 'eager'}
      className={`transition-opacity duration-300 ${
        loaded ? 'opacity-100' : 'opacity-0'
      }`}
      {...props}
    />
  );
};

export default Image; 